import "../scss/style.scss";

import { initializeAlbumCards } from "./album";

initializeAlbumCards();
